import { render, staticRenderFns } from "./WebsiteStarterService.vue?vue&type=template&id=84c4aa98&scoped=true&"
import script from "./WebsiteStarterService.vue?vue&type=script&lang=js&"
export * from "./WebsiteStarterService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c4aa98",
  null
  
)

export default component.exports